module.exports = __webpack_public_path__ + "img/1.63a8933.svg";